import { useEffect, useRef } from 'react';
import { useSetRecoilState } from 'recoil';

import {
  useSetAuthenticationState,
  AuthState,
} from 'state/authenticationState';
import { hasAgentConversationStartedState } from 'state/hasAgentConversationStarted';
import { isLoggedInUser } from 'utils/isLoggedInUser';

import { MessagingServiceEvent } from './messaging-service-plugin';
import { useMessagingServiceStatus } from './useMessagingServiceStatus';

/**
 * early subscription to messagingservice.ready
 * if messagingservice.ready is captured it means
 * user is authenticated in auth journey
 */
export const useLoggedInMessagingServiceReady = () => {
  const initialRef = useRef(false);
  const setAuthenticationState = useSetAuthenticationState();

  const setHasAgentConversationStarted = useSetRecoilState(
    hasAgentConversationStartedState,
  );

  const { setConversationStarting } = useMessagingServiceStatus();

  useEffect(() => {
    if (!initialRef.current) {
      initialRef.current = true;
      window.Genesys('subscribe', MessagingServiceEvent.Ready, () => {
        if (isLoggedInUser()) {
          setAuthenticationState(AuthState.authenticated);
          setHasAgentConversationStarted(true);
          setConversationStarting();
        }
      });
    }
  }, [
    setAuthenticationState,
    setConversationStarting,
    setHasAgentConversationStarted,
  ]);
};
